import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cb2cdb38"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "menu"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", {
    tabindex: "0",
    class: "content"
  })
], -1 /* HOISTED */))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "container" }
const _hoisted_6 = {
  class: "internal-container",
  tabindex: "-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      ref: "buttonInstance",
      class: _normalizeClass(["select", { open: $setup.menuOpen }]),
      onClick: _withModifiers($setup.toggleOpen, ["stop","prevent"]),
      disabled: $setup.buttonDisabled
    }, [
      ($setup.buttonTextKind === 'loading')
        ? (_openBlock(), _createBlock($setup["LoadingGif"], {
            key: 0,
            style: {"margin-right":"-8px","transform-origin":"center","transform":"scale(0.6)","margin-top":"-4px","margin-bottom":"-4px"}
          }))
        : _createCommentVNode("v-if", true),
      _createElementVNode("span", {
        class: _normalizeClass($setup.buttonTextKind)
      }, _toDisplayString($setup.buttonText), 3 /* TEXT, CLASS */),
      _createElementVNode("img", {
        class: "chevron",
        alt: "",
        role: "presentation",
        src: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='' width='18' height='18'%3E%3Cstyle%3E .onDarkBackground%7Bopacity:0.5%7D .onDarkBackground.active,.onDarkBackground.hover%7Bopacity:1%7D .disabled%7Bopacity:0.35!important%7D .active path,.hover path%7Bfill:%23333%7D path,.disabled path%7Bfill:%23666%7D .onDarkBackground path%7Bfill:%23fff!important%7D %3C/style%3E%3Cpath d='M5.8 7.3l3.5 4.6c.1.1.2.1.3 0l3.6-4.6c.1-.2 0-.3-.2-.3H6c-.2 0-.3.1-.2.3z'/%3E%3C/svg%3E",
        style: _normalizeStyle([{"user-select":"none","flex-shrink":"0"}, { transform: $setup.menuOpen ? 'rotate(180deg)' : 'none' }])
      }, null, 4 /* STYLE */)
    ], 10 /* CLASS, PROPS */, _hoisted_1),
    ($setup.menuOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "backdrop",
            onClick: $setup.backdropClicked
          }, _hoisted_4),
          _createElementVNode("div", {
            class: "root",
            style: _normalizeStyle($setup.overlayStyle),
            onClick: $setup.overlayClicked
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.items, (i) => {
                  return (_openBlock(), _createBlock($setup["TableauSelectButton"], {
                    key: i.id,
                    onClicked: ($event: any) => ($setup.itemClicked(i)),
                    isChecked: !$props.multiSelect ? false : $setup.selectedItems.includes(i),
                    text: i.text
                  }, null, 8 /* PROPS */, ["onClicked", "isChecked", "text"]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ], 4 /* STYLE */)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}